import React, { useState, useEffect } from "react";
import { Box, Text, Button } from "@chakra-ui/react";
import Cookies from "js-cookie";

const CookieConsent = () => {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const cookieConsent = Cookies.get("mandatory");
    if (cookieConsent === "true") {
      setAccepted(true);
    }
  }, []);

  const acceptAllCookies = () => {
    Cookies.set("mandatory", "true", { expires: 7 });
    Cookies.set("analytics", "true", { expires: 7 });
    Cookies.set("marketing", "true", { expires: 7 });
    setAccepted(true);
  };

  const acceptMandatoryOnly = () => {
    Cookies.set("mandatory", "true", { expires: 7 });
    setAccepted(true);
  };

  if (accepted) return null;

  return (
    <Box
      flexDir={{ base: "column", md: "row" }}
      display="flex"
      gap={{ base: 4 }}
      zIndex={1000}
      bg="#113F42"
      color="white"
      p={4}
      position="fixed"
      bottom={0}
      w="100%"
      justifyContent="center"
    >
      <Text maxW="813px" className="regular-text">
        We use cookies to improve your experience and ensure our website
        functions properly. You can manage your preferences below. For more
        information, please refer to our{" "}
        <a
          href="/privacy-policy"
          style={{ textDecoration: "underline" }}
          color="#fff"
        >
          Privacy Policy
        </a>
        .
      </Text>
      <Box
        mt={2}
        display="flex"
        flexDir={{ base: "column", sm: "row" }}
        gap={2}
        justifyContent={{ base: "center" }}
      >
        <Button
          onClick={acceptAllCookies}
          h="40px"
          color="#116266"
          borderRadius="9999px"
          w={{ base: "100%", sm: "174px" }}
          bg="#fff"
          fontSize="16px"
          className="medium-text"
        >
          Accept all cookies
        </Button>
        <Button
          onClick={acceptMandatoryOnly}
          h="40px"
          borderRadius="9999px"
          _hover={{ bg: "transparent", color: "whiteAlpha.700" }}
          w={{ base: "100%", sm: "213px" }}
          color="#fff"
          bg="transparent"
          fontSize="16px"
          className="medium-text"
        >
          Accept only mandatory
        </Button>
      </Box>
    </Box>
  );
};

export default CookieConsent;
